import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from './api';

// Import reducers
import supplyChainReducer from './slices/supplyChainSlice';
import simulationsReducer from './slices/simulationsSlice';
import disruptionsReducer from './slices/disruptionsSlice';
import tasksReducer from './slices/tasksSlice';

// Configure the Redux store
const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [api.reducerPath]: api.reducer,
    supplyChain: supplyChainReducer,
    simulations: simulationsReducer,
    disruptions: disruptionsReducer,
    tasks: tasksReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling, etc.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

// Optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

// Export the store and types
export { store };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
